<template>
  <div
    role="region"
    aria-label="Related Department"
    v-show="group.description || group.contactPhone || group.contactEmail"
    :class="classes"
  >
    <div class="asd20-department-contact-card__header">
      <h2 v-show="group.description">{{ group.title }}</h2>
      <p v-show="group.description">{{ group.description }}</p>
    </div>
    <asd20-list
      icon="directory"
      :headline="expanded ? 'Contact Information' : group.title"
    >
      <Asd20ListItem
        v-for="(item, index) in contactListItems"
        :key="index"
        v-bind="item"
        @click.native="onItemClick(item)"
      />
    </asd20-list>
    <asd20-compose-email-modal
      v-if="group"
      :open="composingEmail"
      :recipient-id="group.id"
      @dismiss="composingEmail = false"
    />
  </div>
</template>

<script>
import Asd20List from '../../organisms/Asd20List'
import Asd20ListItem from '../../molecules/Asd20ListItem'
import Asd20ComposeEmailModal from '../../organisms/Asd20ComposeEmailModal'

export default {
  name: 'Asd20DepartmentContactCard',
  components: { Asd20List, Asd20ListItem, Asd20ComposeEmailModal },
  props: {
    group: { type: Object, default: null },
    bordered: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
  },
  data: () => ({
    composingEmail: false,
  }),
  computed: {
    classes() {
      return {
        'asd20-department-contact-card': true,
        'asd20-department-contact-card--bordered': this.bordered,
        'asd20-department-contact-card--expanded': this.expanded,
      }
    },
    contactListItems() {
      if (!this.group) return []

      const baseItemProps = {
        iconSize: 'md',
        alignTop: true,
        actionable: false,
      }

      let items = []

      if (!this.expanded) {
        if (this.group.description) {
          items.push({
            ...baseItemProps,
            icon: 'info',
            label: 'Overview',
            description: this.group.description,
          })
        }
      }

      if (!this.expanded) {
        if (this.group.contactName) {
          items.push({
            ...baseItemProps,
            icon: 'group',
            label: 'Contact',
            description: this.group.contactName,
          })
        }
      }

      if (this.group.contactPhone) {
        items.push({
          ...baseItemProps,
          actionable: true,
          icon: 'phone-alt',
          label: 'Phone',
          description: this.group.contactPhone,
          link: `tel:${this.group.contactPhone}`,
        })
      }

      if (this.group.contactFax) {
        items.push({
          ...baseItemProps,
          icon: 'file',
          label: 'Fax',
          description: `${this.group.contactFax}`,
        })
      }

      if (
        this.group.contactEmail &&
        this.group.contactEmail.indexOf('mailto:') === -1
      ) {
        items.push({
          ...baseItemProps,
          actionable: true,
          alignTop: false,
          icon: 'email',
          label: 'Send an Email',
        })
      }

      if (
        this.group.contactEmail &&
        this.group.contactEmail.indexOf('mailto:') > -1
      ) {
        items.push({
          ...baseItemProps,
          actionable: true,
          icon: 'email',
          label: 'Email',
          description: `${this.group.contactEmail.replace('mailto:', '')}`,
          link: this.group.contactEmail,
        })
      }

      if (this.group.officeHours) {
        items.push({
          ...baseItemProps,
          icon: 'hours-alt',
          label: 'Hours',
          description: this.group.officeHours,
        })
      }

      if (this.group.addressStreet) {
        items.push({
          ...baseItemProps,
          icon: 'map',
          label: 'Location',
          description: `${this.group.buildingName} </br> ${
            this.group.addressStreet
          } </br> ${this.group.addressCity || 'Colorado Springs'}, ${
            this.group.addressState
          }  ${this.group.addressZip}`,
        })
      }

      return items
    },
  },
  methods: {
    onItemClick(item) {
      console.log(item)
      if (item.label === 'Send an Email') {
        this.composingEmail = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

.asd20-department-contact-card {
  &__header {
    display: none;
  }
  &--bordered {
    box-shadow: 0 0 0 1px var(--color__tertiary) inset;
    padding: space(1) space(1) space(0.25) space(1);
  }
  &--expanded {
    padding: space(2) space(2) space(0.25) space(2);
    .asd20-department-contact-card__header {
      margin: space(-2) space(-2) space(0) space(-2);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      &::before {
        content: '';
        position: relative;
        display: block;
        height: space(5);
        width: 100%;
        background-color: var(--color__secondary-t30);
        background-image: url('/statics/images/chalk.png');
        background-position-y: top;
        background-size: 640px auto;
      }
      h2 {
        position: relative;
        font-size: 1.25rem;
        margin-top: space(-4);
        margin-left: space(1);
        margin-right: space(1);
        margin-bottom: 0;
        background: white;
        width: calc(100% - #{space(4)});
        padding: space(0.75) space(1) space(0.25) space(1);
      }
      p {
        position: relative;
        margin: 0 space(1);

        padding: 0 space(1) space(1) space(1);

        background: white;
      }
    }
    .asd20-list {
      margin: 0 space(-1);
    }
  }
  &::v-deep .asd20-list-item--actionable {
    .asd20-list-item__description {
      color: blue;
    }
  }
}

@media (min-width: 1024px) {
  .asd20-department-contact-card {
    &--expanded {
    }
  }
}
</style>
